export default "__VITE_ASSET__CLEYbyUJ__";